import { Box, Stack, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import ServiceQuoteForm from "../../proposal/service-quote-form/ServiceQuoteForm";
import {
  HeroSection,
  HeroFeatureSection,
  AboutSection,
  ServicesSection,
  PackagesSection,
  TestimonialsSection,
  LandingFooter,
  ScrollArrows,
} from "./index";
import NavBar from "./NavBar";
import TawkChat from "./TawkChat";

const testimonials = [
  {
    name: "Dumisani Nkala",
    role: "Client",
    quote:
      "I have attended a number of events where Muzukuru has been working. Most recently a funeral of the dear dad of my friend. The attention to detail, the compassion, the little message cards, the screens so expertly setup, the team who were maneuvring so sensitively around family and mourners but capturing every moment. Muzukuru feels more like a part of the family than a mere service provider. Please keep doing what you do!",
  },
  {
    name: "Simbarashe Mabaya",
    role: "Client",
    quote:
      "During COVID, Muzukuru Streaming broadcasted Mass from St George's College, which became a true lifeline for us. When we moved abroad in the middle of the pandemic, those streamed masses offered not only a vital connection to our faith but also a comforting link to home. It was the highlight of our week. I highly recommend Muzukuru Streaming!",
  },
  {
    name: "Emmanuel Muringani",
    role: "Family Member",
    quote:
      "In a moment of profound sadness, finding a service that is both highly professional and deeply empathetic is rare. The Muzukuru team provided our live stream for our beloved mother's funeral and burial was absolutely exceptional. They were incredibly responsive, accommodating our request on very short notice, and handled everything with compassion and clarity. Their discretion allowed our family to focus entirely on saying our goodbyes. The live stream was crystal clear and stable throughout — a beautiful and dignified way for those who couldn't attend to be part of the service.",
  },
];

export default function LandingPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMuzukuruDomain =
    window.location.hostname === "muzukuru.com" ||
    window.location.hostname === "www.muzukuru.com" ;

  return (
    <Box
      sx={{
        bgcolor: colors.primary[900],
        overflow: "hidden",
        minWidth: { xs: "auto", lg: "1280px" },
        minHeight: "100vh",
        overflowX: { xs: "hidden", lg: "visible" },
      }}
    >
      <NavBar />
      <TawkChat />

      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          pt: { xs: "70px", md: "95px" },
          position: "relative",
          overflow: "hidden",
          borderRadius: "0 0 4rem 4rem",
          background: `
            radial-gradient(ellipse 120% 60% at 50% 100%, rgba(203,135,80,0.33) 0%, transparent 65%),
            radial-gradient(ellipse 80% 40% at 50% 0%, rgba(203,136,80,0.04) 0%, transparent 50%),
            #ffffff
          `,
        }}
      >
        {/* Hero text */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1152px",
            px: { xs: 3, md: "24px" },
            textAlign: "center",
            mb: "48px",
          }}
        >
          <HeroSection
            title="Helping Families Stay Connected When It Matters Most"
            subtitle="Give distant loved ones the chance to be present for every moment. Request a personalised quote today."
          />
        </Box>

        {/* Quote Form */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1152px",
            px: { xs: 2, md: "24px" },
            mt: "40px",
          }}
        >
          <ServiceQuoteForm />
        </Box>

        {/* Scroll Arrow */}
        <Box
          sx={{
            position: "absolute",
            bottom: 24,
            left: "50%",
            transform: "translateX(-50%)",
            display: { xs: "none", md: "block" },
          }}
        >
          <ScrollArrows />
        </Box>
      </Box>

      {isMuzukuruDomain && (
        <>
          {/* We are here for you */}
          <HeroFeatureSection />

          {/* About */}
          <Box sx={{ bgcolor: colors.primary[900] }}>
            <AboutSection />
          </Box>

          {/* Services */}
          <Box sx={{ bgcolor: "#fff8f1" }}>
            <ServicesSection />
          </Box>

          {/* Packages */}
          <Box sx={{ bgcolor: colors.primary[900] }}>
            <PackagesSection />
          </Box>

          {/* Testimonials */}
          <Box sx={{ bgcolor: "#fff8f1" }}>
            <TestimonialsSection testimonials={testimonials} />
          </Box>

          <Stack
            alignItems="center"
            sx={{
              px: { xs: 2, md: 0 },
              py: { xs: "48px", md: "72px" },
              bgcolor: colors.primary[900],
            }}
          >
            <Box sx={{ width: "100%", maxWidth: "900px" }}>
              <ServiceQuoteForm />
            </Box>
          </Stack>

          {/* Footer */}
          <LandingFooter />
        </>
      )}
    </Box>
  );
}
